import React from "react";
import { useHistory } from "react-router-dom";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

export const ResultadosSucursalItem = ( {data} ) => {
  const history = useHistory();
  const GetClass = (value, minimo = 20, medium = 81) => {
    if (value <= minimo) return "circle-red";
    else if (value <= medium) return "circle-yellow";
    else return "circle-success";
  };
  const handleClickResultadosSucursal = () => {
    history.push("/Finanzas/ResultadosSucursal");
  };

  // console.log(data?.inventarioAntiguedad)
  const resultados = data?.resultadosSucursal

  const formatmiles = (number) => {
    return Math.floor((number ?? 0) / 1000).toLocaleString('en-US');
};

const calcularporcentaje = (param, ventasNetas) => {
  if (!ventasNetas) return 0;
  return ((param / ventasNetas) * 100).toFixed(2);
};

  return (
    <div className="dashboard-financiero-container-box-2" onClick={handleClickResultadosSucursal}>
      <div className="dashboard-financiero-container-box-titulo">
        Utilidad Bruta por sucursal
      </div>
      <div className="dashboard-financiero-container-box-info df_box_antiguedad_inventario">
        <table cellPadding={0} cellSpacing={0}>
          {/* <thead>
            <tr>
              <td></td>
              <td>Total</td>
              <td></td>
              <td>Costo</td>
            </tr>
          </thead> */}
          <tbody>
          {resultados.map((item, index) => (
              <tr key={index}>
                <td>{capitalizePalabras(item.sucursal)}</td>
                <td className="ta-center">{formatmiles(item.total)}</td>
                <td className="ta-center">{FormatMoney(item.porcentaje, 2)} %</td>
                {/* <td className="ta-center">{formatmiles(item.suma_Costo)}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
